import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.fluent.saas.light.compact.css';
import './themes/generated/theme.additional.css';
import React, {useEffect} from 'react';
import {BrowserRouter as Router, Navigate, Route, Routes} from 'react-router-dom';
import './dx-styles.scss';
import LoadPanel from 'devextreme-react/load-panel';
import {NavigationProvider} from './contexts/navigation';
import {AuthProvider, useAuth} from './contexts/auth';
import {useScreenSizeClass} from './utils/media-query';
import Content from './Content';
import UnauthenticatedContent from './UnauthenticatedContent';
import config from 'devextreme/core/config';
import {licenseKey} from "./devextreme-license";
import {loadMessages, locale} from "devextreme/localization";
import frMessage from "devextreme/localization/messages/fr.json"
import {LeftSidebarDataContextProvider} from './contexts/refreshDataSource';

import {CookiesProvider} from "react-cookie";
import {QueryClient, QueryClientProvider} from "@tanstack/react-query";

const queryClient = new QueryClient({defaultOptions: {queries: {staleTime: 60 * 1000}}});

function App() {
    const {user, loading} = useAuth();
    if (loading) {
        return <LoadPanel visible={true}/>;
    }

    if (user) {
        return <Content/>;
    }

    return <UnauthenticatedContent/>;
}

export default function Root() {
    config({licenseKey});
    const screenSizeClass = useScreenSizeClass();
    useEffect(() => {
        loadMessages(frMessage);
        locale("fr");
        config({defaultCurrency: "CAD"})
    }, [])
    return (
        <Router>
            <Routes>
                <Route path={':id'}>
                    <Route path={"*"} element={
                        <CookiesProvider>
                            <AuthProvider>
                                <NavigationProvider>
                                    <LeftSidebarDataContextProvider>
                                        <div className={`app ${screenSizeClass}`}>
                                            <QueryClientProvider client={queryClient}>
                                                <App/>
                                            </QueryClientProvider>
                                        </div>
                                    </LeftSidebarDataContextProvider>
                                </NavigationProvider>
                            </AuthProvider>
                        </CookiesProvider>}/>
                    <Route index element={<Navigate to={"login"}/>}/>
                </Route>
                <Route path={"/"} element={
                    <div>Compagnie invalide</div>
                }/>
            </Routes>
        </Router>
    );
}